import React from 'react';
import {
    reduxForm,
} from 'redux-form';
import { Alert, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { Show } from 'Layout';
import { PageStatus, Assets } from 'enums';
import Select from 'react-select';
import { AuthAPI, MasterDataAPI } from "../../API";
import { connect } from "react-redux";
import { authBasicProfile } from "./auth.actions";
import { Grid, Container, TextField, MenuItem, Select as Select2, InputLabel, FormControl } from '@material-ui/core';
import { CountriesAPI } from "../../API/CountriesAPI";
import Language from "../../Languages/Login/content.json";
import { store } from '../../../src/reducers';
import Swal from 'sweetalert2';
import { decryptTkData } from 'Helper/EncryptionDecryption';

export type FormValue = {
    "firstName": string,
    "lastName": string,
    "description": string,
    "features": any,
    "images": any,
    "logo": any,
};

class BasicProfile extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            firstName: '',
            lastName: '',
            mobile: this.props.phoneNumber || '',
            gender: 'Male',
            dateOfBirth: '',
            selectedCountryOption: null,
            selectedStateOption: null,
            selectedCityOption: null,
            countryOptions: [],
            country: '',
            addressLine1: '',
            addressLine2: '',
            state: '',
            city: '',
            pinCode: '',
            referralSource: '',
            countries: [],
            states: [],
            pageContent: this.props.language === 'hi' ? Language.BasicProfileHindi : Language.BasicProfileEnglish,
            cities: [],
            errors: {},
        };
    }

    validateForm = () => {
        let errors: any = {};
        if (!this.state.firstName.trim()) { errors.firstName = "First name is required"; }
        if (!this.state.lastName.trim()) { errors.lastName = "Last name is required"; }
        if (!this.state.mobile.trim()) { errors.mobile = "Mobile number is required"; }
        if (!this.state.gender) { errors.gender = "Gender is required"; }
        if (!this.state.dateOfBirth) { errors.dateOfBirth = "Date of birth is required"; }
        if (!this.state.pinCode.trim()) { errors.pinCode = "Pin code is required"; }
        if (!this.state.addressLine1.trim()) { errors.addressLine1 = "Address Line 1 is required"; }
        if (!this.state.referralSource) { errors.referralSource = "Referral source is required"; }
        if (!this.checkValidDateOfBirth()) { errors.dateOfBirth = `${this.props.language === 'hi' ? 'पैनलिस्ट के रूप में पंजीकरण करने के लिए आपकी आयु 16 वर्ष से अधिक होनी चाहिए ।' : 'You must be above 16 years of Age to register as a panelist.'}`; }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    checkValidDateOfBirth = () => {
        const enteredDate = this.state.dateOfBirth;
        const currentDate = new Date();
        const minAgeDate = new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate());
        const maxAgeDate = new Date(currentDate.getFullYear() - 16, currentDate.getMonth(), currentDate.getDate());
        const selectedDate: any = new Date(enteredDate);
        const enteredTimestamp = selectedDate.getTime();
        const minAgeTimestamp = minAgeDate.getTime();
        const maxAgeTimestamp = maxAgeDate.getTime();
        if (!isNaN(selectedDate) && enteredTimestamp >= minAgeTimestamp && enteredTimestamp <= maxAgeTimestamp) {
            return true;
        }
        return false;
    }


    async componentDidMount() {
        await this.fetchCountryList()
        this.fetchAllStates()
    }

    formValues() {
        return {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            mobile: this.state.mobile,
            gender: this.state.gender,
            dateOfBirth: this.state.dateOfBirth,
            country: this.state.country,
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2 || 'NA',
            state: this.state.state,
            city: this.state.city,
            pinCode: this.state.pinCode,
            referralSource: this.state.referralSource,
            acceptTerms: true

        };
    }


    onSubmit() {
        if (this.props.userId) {
            return this.createProfile();
        }
    }

    createProfile() {
        if (this.props.userId) {
            const valuesIn = this.formValues();
            if (!this.validateForm()) { return; }
            return Promise.resolve()
                .then(() => this.setState({ status: PageStatus.Submitting }))
                .then(() => AuthAPI.createBasicProfile(valuesIn, this.props.userId, this.props.language))
                .then(async (profile) => {
                    if (profile.loginCoupon) {
                        let objSet = {
                            en: `
            <div style="text-align: left;">
              Thank you for signing up on DataXing! <br><br>

              Here’s your ₹100 Barista voucher.<br><br>

              <b>Voucher Code:</b> ${decryptTkData(profile.loginCoupon)}<br>
              <b>Valid till:</b> ${profile.couponExpiryAt}<br>
              Voucher valid only at this Barista outlet.<br><br>
 

              Show this code at the Barista counter and enjoy your coffee on us.<br><br>

              <b>Complete your profile and earn ₹50 more!</b>
              </div>
            `,
                            hi: `
            <div style="text-align: left;">
              DataXing पर साइन-अप करने के लिए धन्यवाद! <br><br>

              यह रहा आपका ₹100 का बरिस्ता वाउचर<br><br>

              <b>वाउचर कोड:</b> ${decryptTkData(profile.loginCoupon)}<br>
              <b>मान्य है:</b> ${profile.couponExpiryAt}<br>
              यह वाउचर सिर्फ इसी बरिस्ता आउटलेट पर मान्य है।<br><br>

              बरिस्ता काउंटर पर यह कोड दिखाएँ और हमारी तरफ़ से कॉफी का मज़ा लें।<br><br>

              <b>अपनी प्रोफ़ाइल पूरी करें और ₹50 और कमाएँ!</b>
              </div>
            `,
                        }
                        await Swal.fire({
                            title: "Success!",
                            icon: "success",
                            html: objSet[this.props.language || 'en'],
                            confirmButtonText: "OK",
                        });

                    }
                    this.setState({ status: PageStatus.Submitted });
                    const state = store.getState();
                    const uniquetokennew = state.adminUser.adminUser.apiToken;
                    return this.props.authBasicProfile(this.props.history, this.props.userId, profile.role, uniquetokennew)
                })
                .catch((error) => {
                    this.setState({ status: PageStatus.Error, error: error.message });
                });
        }
    }


    fetchCountryList(): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => MasterDataAPI.countryList('10'))
            .then((countries) => {
                const options = countries.map(country => ({
                    label: this.props.language === 'hi' ? country.hindi : country.name,
                    value: country.title
                }));
                this.setState({ countries: options, status: PageStatus.Loaded });
                if (options.length > 0) {
                    this.setState({ country: options[0].label, selectedCountryOption: options[0] });
                }
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }


    reset() {
        return this.setState({
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            addressLine1: '',
            addressLine2: '',
            pinCode: '',
            referralSource: ''
        });
    }

    fetchAllStates(): Promise<void> {
        return CountriesAPI.getAllStates(1000)
            .then((statesList) => {
                const options = statesList.map(s => ({
                    label: this.props.language === 'hi' ? s.hindi : s.name,
                    value: s.name,
                    id: s.id,
                }));
                options.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
                this.setState({ states: options });
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    }

    fetchCitiesByStateId(stateId): Promise<void> {
        return CountriesAPI.getUniqueDistrictByStateIds({ stateIds: [stateId] })
            .then((districts) => {
                const options = districts
                    .filter(d => d.segment)
                    .map(d => ({
                        label: d.segment,
                        value: d.segment,
                    }));
                options.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
                this.setState({ cities: options });
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    }

    handleCountryChange = async (selectedCountryOption) => {
        this.setState({
            country: selectedCountryOption.value,
            selectedCountryOption,
            states: [], cities: [],
            selectedStateOption: null, selectedCityOption: null,
            state: '', city: '',
        });
        this.fetchAllStates();
    };

    handleStateChange = async (selectedStateOption) => {
        this.setState({
            state: selectedStateOption.value,
            selectedStateOption,
            cities: [], selectedCityOption: null, city: '',
        });
        if (selectedStateOption.id) {
            this.fetchCitiesByStateId(selectedStateOption.id);
        }
    };

    handleCityChange = async (selectedCityOption) => {
        this.setState({ city: selectedCityOption.value, selectedCityOption });
    };

    fetchStateAndCitiesByZipCode(code): Promise<void> {
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loaded }))
            .then(() => CountriesAPI.getAllCitiesAndStateBasedOnZipCode(1000, code))
            .then((states: any) => {
                if (states.state && states.state.length > 0) {
                    const stateName = states.state[0].title || states.state[0].name;
                    const stateMatch = this.state.states.find((s: any) => s.value === stateName);
                    if (stateMatch) {
                        this.setState({ state: stateMatch.value, selectedStateOption: stateMatch });
                        this.fetchCitiesByStateId(stateMatch.id);
                    }
                }
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }


    handleDateOfBirthChange(e) {
        const enteredDate = e.target.value;
        this.setState((prev) => ({ dateOfBirth: enteredDate, errors: { ...prev.errors, dateOfBirth: "" } }));
    }


    handleZipCodeChange = (event) => {
        const { value } = event.target;
        if (!/^\d*$/.test(value) || value.length > 6) { return; }
        this.setState((prev) => ({ pinCode: value, errors: { ...prev.errors, pinCode: "" } }));
        if (value.length === 6) {
            this.fetchStateAndCitiesByZipCode(value)
        } else {
            this.setState({ state: '', selectedStateOption: null });
            this.setState({ city: '', selectedCityOption: null });
        }
    };

    handleInputChange = (e, regex) => {
        const { value } = e.target;
        if (regex.test(value) || value === '') {
            this.setState((prev) => ({ [e.target.name]: value, errors: { ...prev.errors, [e.target.name]: "" } }));
        }
    };

    // Mirrors AdminNavbarLinks.handleCloseProfile so the forced-profile-completion
    // page logs out the same way the rest of the admin header does.
    handleLogout = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    render() {
        const { selectedCountryOption, selectedStateOption, selectedCityOption, pageContent } = this.state
        const referralsOptions = Language.NewReferrals
        return (
            <Container maxWidth="lg">
                <div className="d-flex justify-content-end mt-2">
                    <button
                        type="button"
                        onClick={this.handleLogout}
                        className="btn btn-link p-0"
                    >
                        Logout
                    </button>
                </div>
                <Grid container justify="center" alignItems="center">
                    <Grid item>
                        <img
                            src={Assets.Logo}
                            alt="Logo"
                            style={{ maxWidth: '100%', maxHeight: '100%', display: 'block' }}
                        />
                    </Grid>
                </Grid>
                <div className='text-center mb-3'>{pageContent.title}</div>
                <Show when={this.state.status === PageStatus.Loading}>
                    <div className="d-flex justify-content-center w-100 p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                </Show>

                <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                    {this.state.error}
                </Alert>
                <form
                    noValidate
                    onSubmit={this.props.handleSubmit((event) => this.onSubmit())}
                    className="mt-4"
                >

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                id="title"
                                label={pageContent.items[2].title}
                                className="form-control"
                                name="firstName"
                                onChange={(e) => this.handleInputChange(e, /^[a-zA-Z]*$/)}
                                value={this.state.firstName}
                                placeholder={pageContent.items[1].title}
                                error={!!this.state.errors.firstName}
                                required
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                id="lastName"
                                label={pageContent.items[3].title}
                                className="form-control"
                                name="lastName"
                                onChange={(e) => this.handleInputChange(e, /^[a-zA-Z]*$/)}
                                value={this.state.lastName}
                                placeholder={pageContent.items[1].title}
                                error={!!this.state.errors.lastName}
                                required
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                id="mobile"
                                label={pageContent.items[4].title}
                                className="form-control"
                                name="mobile"
                                onChange={(e) => this.handleInputChange(e, /^\d*$/)}
                                value={this.state.mobile}
                                placeholder={pageContent.items[1].title}
                                error={!!this.state.errors.mobile}
                                required
                            />
                        </Grid>
                    </Grid>
                    <br />

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <FormControl style={{ width: '100%' }}>
                                <InputLabel htmlFor="gender">{pageContent.items[5].title}</InputLabel>
                                <Select2
                                    value={this.state.gender}
                                    onChange={(e) => this.setState({ gender: e.target.value })}
                                    inputProps={{
                                        name: 'gender',
                                        id: 'gender',
                                    }}
                                    required
                                >
                                    <MenuItem value="" disabled>--Choose--</MenuItem>
                                    <MenuItem value="Male">{this.props.language === 'hi' ? 'पुरुष' : 'Male'}</MenuItem>
                                    <MenuItem value="Female">{this.props.language === 'hi' ? 'महिला' : 'Female'}</MenuItem>
                                    <MenuItem value="Other">{this.props.language === 'hi' ? 'अन्य' : 'Other'}</MenuItem>
                                </Select2>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                id="description"
                                label={pageContent.items[6].title}
                                type="date"
                                defaultValue={null}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(e) => this.handleDateOfBirthChange(e)}
                                error={!!this.state.errors.dateOfBirth}
                                helperText={this.state.errors.dateOfBirth}
                                required
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                id="pinCode"
                                label={pageContent.items[7].title}
                                value={this.state.pinCode}
                                onChange={(e) => this.handleZipCodeChange(e)}
                                placeholder={pageContent.items[1].title}
                                error={!!this.state.errors.pinCode}
                                required
                            />
                        </Grid>
                    </Grid>
                    <br />

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                id="addressLine1"
                                label={pageContent.items[8].title}
                                className="form-control"
                                name="addressLine1"
                                value={this.state.addressLine1}
                                onChange={(e) => this.setState((prev: any) => ({ addressLine1: e.target.value, errors: { ...prev.errors, addressLine1: "" } }))}
                                placeholder={pageContent.items[1].title}
                                error={!!this.state.errors.addressLine1}
                                required
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="addressLine2"
                                label={pageContent.items[9].title}
                                className="form-control"
                                name="addressLine2"
                                value={this.state.addressLine2}
                                onChange={(e) => this.setState({ addressLine2: e.target.value })}
                                placeholder={pageContent.items[1].title}
                            />
                        </Grid>
                    </Grid>
                    <br />

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Select
                                name='countryTitle'
                                id='countryTitle'
                                onChange={this.handleCountryChange}
                                value={selectedCountryOption}
                                required
                                placeholder={pageContent.items[10].title}
                                options={this.state.countries}
                                isDisabled={true}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <Select
                                name='state'
                                id='state'
                                onChange={this.handleStateChange}
                                value={selectedStateOption}
                                required
                                placeholder={pageContent.items[11].title}
                                options={this.state.states}
                            />
                            {this.state.errors.state && (
                                <p className="text-danger" style={{ fontSize: "12px" }}>
                                    {this.state.errors.state}
                                </p>
                            )}
                        </Grid>
                        <Grid item xs={4}>
                            <Select
                                name='city'
                                id='city'
                                onChange={this.handleCityChange}
                                value={selectedCityOption}
                                placeholder={pageContent.items[12].title}
                                required
                                options={this.state.cities}
                            />
                            {this.state.errors.city && (
                                <p className="text-danger" style={{ fontSize: "12px" }}>
                                    {this.state.errors.city}
                                </p>
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <label htmlFor='referralSource'>{pageContent.items[13].title + "*"}</label>
                        <select
                            style={{
                                width: '100%',
                                display: 'block',
                                height: '40px',
                                lineHeight: '1.5',
                                color: '#495057',
                                backgroundColor: '#fff',
                                backgroundClip: 'padding-box',
                                border: `1px solid ${this.state.errors.referralSource ? 'red' : '#ced4da'}`,
                                borderRadius: '5px',
                                transition:
                                    'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                            }}
                            name='referralSource'
                            id='referralSource'
                            value={this.state.referralSource}
                            required
                            onChange={(e) =>
                                this.setState((prev) => ({ referralSource: e.target.value, errors: { ...prev.errors, referralSource: "" } }))
                            }
                        >
                            <option value="" className="">{this.props.language === 'hi' ? "रेफरल स्रोत चुनें" : "Select referral source"}</option>
                            {referralsOptions.map((referral) => (
                                <option key={referral.value} value={referral.value} className="">{this.props.language === 'hi' ? referral.label.hi : referral.label.en}</option>
                            ))}
                        </select>
                        {this.state.errors.referralSource && (
                            <p className="text-danger" style={{ fontSize: "12px" }}>
                                {this.state.errors.referralSource}
                            </p>
                        )}
                    </Grid>
                    <hr />
                    <div className="mt-2 d-flex justify-content-center">
                        <button
                            type="submit"
                            disabled={false}
                            className="btn btn-primary mr-3"
                        >
                            {pageContent.items[14].title}
                        </button>

                        <button
                            type="button"
                            disabled={false}
                            onClick={() => this.reset()}
                            className="btn btn-light mr-3"
                        >
                            {pageContent.items[15].title}
                        </button>

                        <Show when={this.state.status === PageStatus.Submitting}>
                            <Spinner animation="border" variant="primary" />
                        </Show>
                    </div>
                </form>
            </Container>
        );
    }
}

const basicProfileFormRedux = reduxForm<FormValue, any>({
    form: 'profileForm',
})(BasicProfile);

const mapStateToProps = (state: { adminUser: { adminUser: { phoneNumber: any, email: any, language: any, userId: any; token: any; loading: any; error: any; role: any }; }; }) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        language: state.adminUser.adminUser.language,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
    };
};

const BasicProfileWithRouter = withRouter(connect(mapStateToProps, { authBasicProfile })(basicProfileFormRedux));

export { BasicProfileWithRouter as BasicProfile };
